<template>
  <div class="grid-container">
    <div class="lock-container"
      v-if="locked">
        <img src="../assets/art/locked_icon.png"/>
      </div>
    <div
      v-for="(row, rowIndex) in 4"
      :key="rowIndex"
    >
      <div
        v-for="(col, colIndex) in 4"
        :key="`${rowIndex}-${colIndex}`"
        class="grid-cell"
        :style="getCellStyle(rowIndex, colIndex)"
        @click="handleCellClick(rowIndex,colIndex)"
      />
    </div>
  </div>
</template>

<script >




export default {
  name:"TetrisPieceRenderer",
  props: {
    pieceType:{
      type:String,
      required:true
    },
    squareSize:{
      type:Number,
      required:true
    },
    locked:{
      type:Boolean,
      default:false
    },
    isPlaced:{
      type:Boolean,
      default:false
    },
    eventReached:{
      type:Boolean,
      default:false
    }
  },
  computed:{
    booleanMatrix(){
      switch(this.pieceType){
        case "o":
          return [
            [1,1,0,0],
            [1,1,0,0],
            [0,0,0,0],
            [0,0,0,0],
          ]
        case "i":
          return [
            [1,1,1,1],
            [0,0,0,0],
            [0,0,0,0],
            [0,0,0,0],
          ]
        case "z":
          return [
            [1,1,0,0],
            [0,1,1,0],
            [0,0,0,0],
            [0,0,0,0],
          ]
        case "s":
          return [
            [0,1,1,0],
            [1,1,0,0],
            [0,0,0,0],
            [0,0,0,0],
          ]
        case "t":
          return [
            [1,1,1,0],
            [0,1,0,0],
            [0,0,0,0],
            [0,0,0,0],
          ]
        case "l":
          return [
            [1,1,1,0],
            [1,0,0,0],
            [0,0,0,0],
            [0,0,0,0],
          ]
        case "j":
          return [
            [1,1,1,0],
            [0,0,1,0],
            [0,0,0,0],
            [0,0,0,0],
          ]
        default:
          return [
            [1,1,0,0],
            [1,1,0,0],
            [0,0,0,0],
            [0,0,0,0],
          ]
          
      }
    }
  },
  methods:{
    getCellStyle(rowIndex, colIndex) {
      /*
      let shadow = ''
      //if nothing is to the right add right box shadow
      if(colIndex==3||!this.booleanMatrix[rowIndex][colIndex+1]){
        shadow +='5px 0px 5px -2px rgba(0,0,0,0.3),'
      }
      if(colIndex==0||!this.booleanMatrix[rowIndex][colIndex-1]){
        shadow +='-5px 0px 5px -2px rgba(0,0,0,0.3),'
      }
      if(rowIndex==3||!this.booleanMatrix[rowIndex+1][colIndex]){
        shadow +='0px 5px 5px -2px rgba(0,0,0,0.3)'
      }*/
      return {
        position: 'absolute',
        top: `${rowIndex * this.squareSize}px`,
        left: `${colIndex * this.squareSize}px`,
        width: `${this.squareSize}px`,
        height: `${this.squareSize}px`,
        backgroundColor:this.locked?'rgba(50,50,50,0.3)':'',
        //backgroundSize: `${gridSize * 100}% ${gridSize * 100}%`,
        //backgroundPosition: `${colIndex * 100}% ${rowIndex * 100}%`,
        //backgroundRepeat: 'no-repeat',
        visibility: this.booleanMatrix[rowIndex][colIndex]? "visible": "hidden",
        cursor:!this.eventReached && this.isPlaced && this.booleanMatrix[rowIndex][colIndex]? "pointer": "auto",
        pointerEvents: !this.eventReached && this.isPlaced && this.booleanMatrix[rowIndex][colIndex]? "auto": "none",
        
      }
    },
    handleCellClick(row,col){
      if(this.booleanMatrix[row][col]){
        this.$emit('open-description')
      }
    }
  }

}

</script>

<style scoped>
.grid-container {
  position: relative;
  width: 100%;
  height:100%;
}

.lock-container {
  position:absolute;
  width:inherit;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items:center;
  z-index:5
}

.lock-container img {
  width:30px;
}


</style>
